import { Injectable } from '@angular/core';
import {httpOptions} from '../../configurations/configuration';
import { HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class ProductConfigurationService {

    constructor(private http: HttpClient) { }

    updateProductConfiguration(postObj:any) : Observable<any> {
        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.updateProductConfigurationUrl, postObj,httpOptions);
    }
        
    insertProductConfiguration(postObj:any) : Observable<any> {
        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.insertProductConfigurationUrl, postObj,httpOptions);
    }  

    

    
    getProductConfiguration( id: any) : Observable<any> {
        
        if(id){
            
        } else {
            id = 1;
        }
        
         return this.http.get(environment.apiURL + environment.adminApiUrl + environment.getProductConfigurationUrl+"/" + id);
    }
   
    getAllGeoZone(filterObj,start,limit){

      // filterObj.languageId = localStorage.getItem('languageId');

        let urlGetAllGoeZone = environment.apiURL + environment.adminApiUrl + environment.getGeoZoneUrl +'?filter='+encodeURIComponent(JSON.stringify(filterObj))+'&start='+start+'&limit='+limit;
        return this.http.get<any>(urlGetAllGoeZone)
    }
         
                
  async uploadFile(file, path) {

    var parts = file.name.split('.');
    let fileNameWithoutExtension = parts[0];
    let fileExtention = (parts.length > 1) ? parts.pop() : '';

    let fullFileName = '';
    if (fileExtention) {
      fullFileName = path + fileNameWithoutExtension + '-' + new Date().getTime() + "." + fileExtention;
    } else {
      fullFileName = path + fileNameWithoutExtension + '-' + new Date().getTime();
    }

    let getUrlPresigned: any = {};

    getUrlPresigned = await this.http.post(environment.apiURL + 'getsignedurl', { key: fullFileName }).toPromise();

    let uploadUrlPresigned: any = {};
    uploadUrlPresigned = await this.http.put(getUrlPresigned.data.url, file).toPromise();


    if (uploadUrlPresigned == null) {
      return getUrlPresigned.data

    }
  }   
                    
                
                   
    }
                             